/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2SearchHistory/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2SearchHistory({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2SearchHistory",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2SearchHistory.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-1zO9rg': alignSelf,'--mt-2-1zO9rg': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1zO9rg': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1zO9rg': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1zO9rg': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1zO9rg': opacity,'--w-10-1zO9rg': typeof width === 'number' ? `${width}px` : width,'--h-11-1zO9rg': typeof height === 'number' ? `${height}px` : height,'--f-12-1zO9rg': fill,'--a-7-1zO9rg': isAnimated ? animation : "none",'--sd-8-1zO9rg': isAnimated ? strokeDashoffset : 0,'--sd-9-1zO9rg': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2SearchHistory.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M0 1.375C0 .615.615 0 1.374 0h6.414c.76 0 1.374.616 1.374 1.375v3.46a4.156 4.156 0 00-4.18 5.25H1.374A1.375 1.375 0 010 8.71V1.375zm6.872 1.949a.573.573 0 000-1.146H2.29a.573.573 0 000 1.146h4.58zM5.154 5.043a.573.573 0 01-.573.573h-2.29a.573.573 0 010-1.146h2.29c.316 0 .573.256.573.573zM8.99 12A3.01 3.01 0 0012 8.989 3.01 3.01 0 108.99 12zm1.157-4.17a.573.573 0 010 .811l-.752.753a.572.572 0 11-.81-.81l.752-.753a.572.572 0 01.81 0z"
 style={{'--f-12-1zO9rg': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}